import React, { useState } from 'react';
import { PageHeader, Card, FormGroup, Input, Select, Button, DataTable, ActionButtons, SectionDivider, Badge } from '../../components/common/UIComponents';
import { VendorController, VendorContractController, VendorBillingController } from '../../controllers';

const ratings = ['1 Star', '2 Stars', '3 Stars', '4 Stars', '5 Stars'];


export function AddVendorsPage() {
  const [vendors, setVendors] = useState(VendorController.getAll());
  const [form, setForm] = useState({ name: '', service: '', contact: '', phone: '', gst: '', pan: '', email: '', address: '', amcStart: '', amcEnd: '', facility: '', alertDays: '', rating: '', opening: '', head: '', group: '' });
  const [editing, setEditing] = useState(null);
  const refresh = () => setVendors(VendorController.getAll());

  const handleSubmit = () => {
    if (!form.name) return;
    const rec = { ...form, opening: parseFloat(form.opening) || 0 };
    editing ? VendorController.update(editing, rec) : VendorController.add(rec);
    setForm({ name: '', service: '', contact: '', phone: '', gst: '', pan: '', email: '', address: '', amcStart: '', amcEnd: '', facility: '', alertDays: '', rating: '', opening: '', head: '', group: '' });
    setEditing(null);
    refresh();
  };

  const columns = [
    { key: 'id', label: '#' },
    { key: 'name', label: 'Vendor Name' },
    { key: 'service', label: 'Service' },
    { key: 'phone', label: 'Phone' },
    { key: 'opening', label: 'Opening', className: 'td-mono',
      render: r => <span className={`td-amount ${r.opening >= 0 ? 'credit' : 'debit'}`}>₹{Math.abs(r.opening || 0).toLocaleString('en-IN')}</span> },
    { key: 'head', label: 'A/c Head' },
    { key: 'group', label: 'A/c Group' },
    { key: 'actions', label: 'Edit/Del', render: row => (
      <ActionButtons
        onEdit={() => { setForm({ name: row.name, service: row.service || '', contact: row.contact || '', phone: row.phone || '', gst: row.gst || '', pan: row.pan || '', email: row.email || '', address: row.address || '', amcStart: '', amcEnd: '', facility: '', alertDays: '', rating: row.rating || '', opening: row.opening?.toString() || '', head: row.head || '', group: row.group || '' }); setEditing(row.id); }}
        onDelete={() => { VendorController.delete(row.id); refresh(); }}
      />
    )},
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Vendor Management" description="Add and manage service vendors" />
      <Card title="Add Vendor" style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Vendor Company Name" required><Input placeholder="Enter Vendor Company Name" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} /></FormGroup>
          <FormGroup label="Service" required><Input placeholder="Enter Service Type" value={form.service} onChange={e => setForm(p => ({ ...p, service: e.target.value }))} /></FormGroup>
          <FormGroup label="Contact Person Name" required><Input placeholder="Enter Contact Person Name" value={form.contact} onChange={e => setForm(p => ({ ...p, contact: e.target.value }))} /></FormGroup>
          <FormGroup label="Phone Number" required><Input placeholder="Enter Phone No" value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} /></FormGroup>
          <FormGroup label="GST No"><Input placeholder="Enter GST No" value={form.gst} onChange={e => setForm(p => ({ ...p, gst: e.target.value }))} /></FormGroup>
          <FormGroup label="PAN No"><Input placeholder="Enter PAN No" value={form.pan} onChange={e => setForm(p => ({ ...p, pan: e.target.value }))} /></FormGroup>
          <FormGroup label="Company Email Address"><Input placeholder="Enter EmailId" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} /></FormGroup>
          <FormGroup label="Address"><Input placeholder="Enter Address" value={form.address} onChange={e => setForm(p => ({ ...p, address: e.target.value }))} /></FormGroup>
          <FormGroup label="Rating"><Select value={form.rating} onChange={e => setForm(p => ({ ...p, rating: e.target.value }))} options={ratings} placeholder="Select" /></FormGroup>
          <FormGroup label="AMC Start Date"><Input type="date" value={form.amcStart} onChange={e => setForm(p => ({ ...p, amcStart: e.target.value }))} /></FormGroup>
          <FormGroup label="AMC End Date"><Input type="date" value={form.amcEnd} onChange={e => setForm(p => ({ ...p, amcEnd: e.target.value }))} /></FormGroup>
          <FormGroup label="Alert Days"><Input type="number" placeholder="Enter AMC Expiry Alert Days" value={form.alertDays} onChange={e => setForm(p => ({ ...p, alertDays: e.target.value }))} /></FormGroup>
          <FormGroup label="Opening Balance"><Input type="number" placeholder="Enter Opening Balance" value={form.opening} onChange={e => setForm(p => ({ ...p, opening: e.target.value }))} /></FormGroup>
          <FormGroup label="Account Head"><Select value={form.head} onChange={e => setForm(p => ({ ...p, head: e.target.value }))} options={['Assets', 'Liabilities', 'Incomes', 'Expenses']} placeholder="select" /></FormGroup>
          <FormGroup label="Account Group"><Select value={form.group} onChange={e => setForm(p => ({ ...p, group: e.target.value }))} options={['Expenses', 'Income', 'Contributions']} placeholder="Select" /></FormGroup>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleSubmit}>{editing ? 'Update Vendor' : 'Add Vendor'}</Button>
          <Button variant="secondary">Refresh</Button>
          {editing && <Button variant="ghost" onClick={() => setEditing(null)}>Cancel</Button>}
        </div>
      </Card>
      <SectionDivider />
      <DataTable title="Vendors Details" columns={columns} data={vendors}
        onSearch={q => VendorController.search(q, ['name', 'service', 'phone'])} />
    </div>
  );
}

export function VendorContractPage() {
  const [contracts, setContracts] = useState(VendorContractController.getAll());
  const vendors = VendorController.getAll().map(v => v.name);
  const [form, setForm] = useState({ vendor: '', title: '', contractNo: '', amount: '', startDate: '', endDate: '', remarks: '' });
  const [editing, setEditing] = useState(null);
  const refresh = () => setContracts(VendorContractController.getAll());

  const handleSubmit = () => {
    if (!form.vendor) return;
    const rec = { ...form, amount: parseFloat(form.amount) || 0 };
    editing ? VendorContractController.update(editing, rec) : VendorContractController.add(rec);
    setForm({ vendor: '', title: '', contractNo: '', amount: '', startDate: '', endDate: '', remarks: '' });
    setEditing(null); refresh();
  };

  const columns = [
    { key: 'id', label: '#' },
    { key: 'vendor', label: 'Vendor' },
    { key: 'contractNo', label: 'Contract No', className: 'td-mono' },
    { key: 'amount', label: 'Amount', render: r => <span className="td-amount credit">₹{r.amount?.toLocaleString('en-IN')}</span> },
    { key: 'startDate', label: 'Start Date' },
    { key: 'endDate', label: 'End Date', render: r => {
      const expired = r.endDate && new Date(r.endDate) < new Date();
      return <span style={{ color: expired ? 'var(--accent-red)' : 'var(--accent-green)' }}>{r.endDate}</span>;
    }},
    { key: 'actions', label: 'Edit/Del', render: row => (
      <ActionButtons onEdit={() => { setForm({ vendor: row.vendor, title: row.title || '', contractNo: row.contractNo, amount: row.amount?.toString(), startDate: row.startDate, endDate: row.endDate, remarks: row.remarks || '' }); setEditing(row.id); }} onDelete={() => { VendorContractController.delete(row.id); refresh(); }} />
    )},
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Vendor Contract" description="Manage vendor contracts and AMC agreements" />
      <Card title="Add Contract" style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Vendor" required><Select value={form.vendor} onChange={e => setForm(p => ({ ...p, vendor: e.target.value }))} options={vendors} placeholder="select" /></FormGroup>
          <FormGroup label="Contract Title" required><Input placeholder="Enter Contract Title" value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} /></FormGroup>
          <FormGroup label="Contract No" required><Input placeholder="Enter Contract No" value={form.contractNo} onChange={e => setForm(p => ({ ...p, contractNo: e.target.value }))} /></FormGroup>
          <FormGroup label="Amount"><Input type="number" placeholder="Enter Amount" value={form.amount} onChange={e => setForm(p => ({ ...p, amount: e.target.value }))} /></FormGroup>
          <FormGroup label="Start Date"><Input type="date" value={form.startDate} onChange={e => setForm(p => ({ ...p, startDate: e.target.value }))} /></FormGroup>
          <FormGroup label="End Date"><Input type="date" value={form.endDate} onChange={e => setForm(p => ({ ...p, endDate: e.target.value }))} /></FormGroup>
        </div>
        <FormGroup label="Remarks" style={{ marginBottom: 14 }}><Input placeholder="Enter Remarks" value={form.remarks} onChange={e => setForm(p => ({ ...p, remarks: e.target.value }))} /></FormGroup>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleSubmit}>{editing ? 'Update Contract' : 'Add Contract'}</Button>
          <Button variant="secondary">Refresh</Button>
        </div>
      </Card>
      <SectionDivider />
      <DataTable title="Vendors Details" columns={columns} data={contracts} onSearch={q => VendorContractController.search(q, ['vendor', 'contractNo'])} />
    </div>
  );
}

export function VendorBillingPage() {
  const [bills] = useState([]);
  const vendors = VendorController.getAll().map(v => v.name);
  const [form, setForm] = useState({ vendor: '', billType: '', contractType: '', billNo: '', billDate: '', dueDate: '', poNo: '', title: '', remarks: '' });

  const columns = [
    { key: 'id', label: '#' },
    { key: 'vendor', label: 'Vendor' },
    { key: 'type', label: 'Bill Type', render: r => <Badge color="blue">{r.type}</Badge> },
    { key: 'billNo', label: 'Bill No', className: 'td-mono' },
    { key: 'billDate', label: 'Bill Date' },
    { key: 'totalNet', label: 'Total Net Amount', render: r => <span className="td-amount debit">₹{r.totalNet?.toLocaleString('en-IN')}</span> },
    { key: 'paid', label: 'Total Paid', render: r => <span className="td-amount credit">₹{r.paid?.toLocaleString('en-IN')}</span> },
    { key: 'balance', label: 'Balance', render: r => <span className={`td-amount ${r.balance > 0 ? 'debit' : 'credit'}`}>₹{r.balance?.toLocaleString('en-IN')}</span> },
    { key: 'dueDate', label: 'Due Date' },
    { key: 'print', label: 'Print', render: () => <Button size="sm" variant="secondary">Print</Button> },
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Vendor Billing" description="Create and manage vendor invoices" />
      <Card title="Vendor Billing" style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
          <FormGroup label="Vendor / Party" required><Select value={form.vendor} onChange={e => setForm(p => ({ ...p, vendor: e.target.value }))} options={vendors} placeholder="select" /></FormGroup>
          <FormGroup label="Bill Type"><Select value={form.billType} onChange={e => setForm(p => ({ ...p, billType: e.target.value }))} options={['sales', 'purchase', 'debit note', 'credit note']} placeholder="select" /></FormGroup>
          <FormGroup label="Contract Type"><Select value={form.contractType} onChange={e => setForm(p => ({ ...p, contractType: e.target.value }))} options={['AMC', 'One Time', 'Yearly']} placeholder="select" /></FormGroup>
          <FormGroup label="Bill No"><Input placeholder="Enter Bill No" value={form.billNo} onChange={e => setForm(p => ({ ...p, billNo: e.target.value }))} /></FormGroup>
          <FormGroup label="Bill Date"><Input type="date" value={form.billDate} onChange={e => setForm(p => ({ ...p, billDate: e.target.value }))} /></FormGroup>
          <FormGroup label="Due Date"><Input type="date" value={form.dueDate} onChange={e => setForm(p => ({ ...p, dueDate: e.target.value }))} /></FormGroup>
          <FormGroup label="PO No"><Input placeholder="Enter PO No" value={form.poNo} onChange={e => setForm(p => ({ ...p, poNo: e.target.value }))} /></FormGroup>
          <FormGroup label="Title" required><Input placeholder="Enter Title" value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} /></FormGroup>
          <FormGroup label="Remarks"><Input placeholder="Enter Remarks" value={form.remarks} onChange={e => setForm(p => ({ ...p, remarks: e.target.value }))} /></FormGroup>
        </div>
        <Button variant="secondary">Refresh</Button>
      </Card>
      <DataTable title="Vendor Bills" columns={columns} data={bills} onSearch={q => VendorBillingController.search(q, ['vendor', 'billNo'])} />
    </div>
  );
}

export function VendorReportPage() {
  const vendors = VendorController.getAll().map(v => v.name);
  const [vendor, setVendor] = useState('Mahesh CCTV Company Pvt Ltd');
  const [from, setFrom] = useState('2025-04-01');
  const [to, setTo] = useState('2026-02-01');

  const reportData = [
    { date: '20-04-2025', voucherType: 'SALES BILL', voucherNo: 'EXL2023-2024001', particulars: 'Amount: 11232.00, igst: 1010.88, tds: 224.64', drAmount: 13029.00, crAmount: 0.00, closing: '558,959.00 DR' },
    { date: '07-07-2025', voucherType: 'SALES BILL', voucherNo: '99', particulars: 'Purchased Camera Amount: 12000.00, tds: 120.00', drAmount: 11880.00, crAmount: 0.00, closing: '570,839.00 DR' },
  ];

  return (
    <div className="fade-in">
      <PageHeader title="Vendor Report" description="View vendor ledger and transaction history" />
      <Card style={{ marginBottom: 20 }}>
        <div className="form-grid form-grid-4" style={{ marginBottom: 14 }}>
          <FormGroup label="Select Vendor"><Select value={vendor} onChange={e => setVendor(e.target.value)} options={vendors} placeholder="Select" /></FormGroup>
          <FormGroup label="From Date"><Input type="date" value={from} onChange={e => setFrom(e.target.value)} /></FormGroup>
          <FormGroup label="To Date"><Input type="date" value={to} onChange={e => setTo(e.target.value)} /></FormGroup>
          <FormGroup label="&nbsp;"><div style={{ display: 'flex', gap: 8, paddingTop: 4 }}><Button>Search</Button><Button variant="amber" style={{ background: '#d97706', color: '#fff' }}>Print / Save as PDF</Button><Button variant="success">Export to Excel</Button></div></FormGroup>
        </div>
      </Card>

      {vendor && (
        <Card title={`Vendor Ledger — ${vendor}`}>
          <div style={{ marginBottom: 12 }}>
            <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Period: From {from} To {to}</p>
          </div>
          <div className="table-wrapper">
            <table>
              <thead><tr><th>Date</th><th>Vou Type</th><th>Vou No</th><th>Particulars</th><th>Bank/AcNo</th><th>Dr. Amount</th><th>Cr. Amount</th><th>Closing</th></tr></thead>
              <tbody>
                {reportData.map((r, i) => (
                  <tr key={i}>
                    <td>{r.date}</td>
                    <td><Badge color="blue">{r.voucherType}</Badge></td>
                    <td className="td-mono">{r.voucherNo}</td>
                    <td style={{ fontSize: '0.75rem', color: 'var(--text-muted)', maxWidth: 200 }}>{r.particulars}</td>
                    <td>-</td>
                    <td className="td-amount debit">₹{r.drAmount?.toLocaleString('en-IN')}</td>
                    <td className="td-amount">₹{r.crAmount?.toLocaleString('en-IN')}</td>
                    <td className="td-mono" style={{ color: 'var(--accent-red)' }}>{r.closing}</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: 700 }}>
                  <td colSpan={5} style={{ textAlign: 'right', paddingRight: 16 }}>Total</td>
                  <td className="td-amount debit">₹570,839</td>
                  <td className="td-amount">₹0.00</td>
                  <td className="td-mono" style={{ color: 'var(--accent-red)' }}>570,839.00DR</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
